import { Routes } from '@angular/router';
import { roleGuard } from './guards/role-guard.guard';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'matches',
    pathMatch: 'full',
  },
  {
    path: 'group-matches/new',
    loadComponent: () =>
      import('./pages/new-group-match/new-group-match.page').then(
        (c) => c.NewGroupMatchPage,
      ),
    pathMatch: 'full',
    canActivate: [roleGuard],
  },
  {
    path: 'group-matches/:groupMatchId',
    loadComponent: () =>
      import('./pages/group-match/group-match.page').then(
        (c) => c.GroupMatchPage,
      ),
    pathMatch: 'full',
    canActivate: [roleGuard],
  },
  {
    path: 'groups/:horseGroupId',
    loadComponent: () =>
      import('./pages/horse-group/horse-group.page').then(
        (c) => c.HorseGroupPage,
      ),
    pathMatch: 'full',
    canActivate: [roleGuard],
  },
  {
    path: 'mares/:horseId',
    loadComponent: () =>
      import('./pages/mare/mare.page').then((c) => c.MarePage),
    pathMatch: 'full',
    canActivate: [roleGuard],
  },
  {
    path: 'matches/new',
    loadComponent: () =>
      import('./pages/new-match/new-match.page').then((c) => c.NewMatchPage),
    pathMatch: 'full',
    canActivate: [roleGuard],
  },
  {
    path: 'matches/:matchId',
    loadComponent: () =>
      import('./pages/match/match.page').then((c) => c.MatchPage),
    pathMatch: 'full',
    canActivate: [roleGuard],
  },
  {
    path: 'stallions/:horseId',
    loadComponent: () =>
      import('./pages/stallion/stallion.page').then((c) => c.StallionPage),
    pathMatch: 'full',
    canActivate: [roleGuard],
  },
  {
    path: 'group-matches',
    loadComponent: () =>
      import('./pages/group-matches/group-matches.page').then(
        (c) => c.GroupMatchesPage,
      ),
    pathMatch: 'full',
    canActivate: [roleGuard],
  },
  {
    path: 'groups',
    loadComponent: () =>
      import('./pages/horse-groups/horse-groups.page').then(
        (c) => c.HorseGroupsPage,
      ),
    pathMatch: 'full',
    canActivate: [roleGuard],
  },
  {
    path: 'login',
    loadComponent: () =>
      import('./pages/login/login.page').then((c) => c.LoginPage),
    pathMatch: 'full',
  },
  {
    path: 'mares',
    loadComponent: () =>
      import('./pages/mares/mares.page').then((c) => c.MaresPage),
    pathMatch: 'full',
    canActivate: [roleGuard],
  },
  {
    path: 'matches',
    loadComponent: () =>
      import('./pages/matches/matches.page').then((c) => c.MatchesPage),
    pathMatch: 'full',
    canActivate: [roleGuard],
  },
  {
    path: 'not-authorized',
    loadComponent: () =>
      import('./pages/not-authorized/not-authorized.page').then(
        (c) => c.NotAuthorizedPage,
      ),
    pathMatch: 'full',
  },
  {
    path: 'stallions',
    loadComponent: () =>
      import('./pages/stallions/stallions.page').then((c) => c.StallionsPage),
    pathMatch: 'full',
    canActivate: [roleGuard],
  },
  {
    path: 'switch-user',
    loadComponent: () =>
      import('./pages/switch-user/switch-user.page').then(
        (c) => c.SwitchUserPage,
      ),
    pathMatch: 'full',
    canActivate: [roleGuard],
  },
  {
    path: 'users',
    loadComponent: () =>
      import('./pages/users/users.page').then((c) => c.UsersPage),
    pathMatch: 'full',
    canActivate: [roleGuard],
    data: { roles: ['Administrator'] },
  },
];
